import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/en-gb";

//component
import LoanApplicationCard from "./LoanApplicationCard";
import SearchFilter from "../CustomUIComponents/SearchFilter/SearchFilter";
import Pagination from "../CustomUIComponents/Pagination/Pagination";

//Constants
import {
  LOAN_APPLICATION_CATEGORY,
  LOAN_CATEGORY_LEGEND,
} from "../Utils/Constants";
import {
  DEFAULT_PAGINATION_ACTIVE_PAGE,
  DEFAULT_PAGINATION_RECORDS_COUNT,
} from "../CustomUIComponents/Pagination/PaginationConstants";

//Utilities
import Utility from "../Utils/Utility";

//Styles
import "./LoanApplicationList.scss";

//Strings
import { Strings } from "../Translations/i18n";
import { Button } from "react-bootstrap";
import CustomModal from "../CustomUIComponents/CustomModal/CustomModal";
import ViewArchievedData from "./ViewArchievedData";

export default class LoanApplicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCategory: props.searchFilter.fc,
      searchLoanID: props.searchFilter.lid,
      applicationId: "",
      recordsPerPage: props.searchFilter.lmt,
      activePage: props.searchFilter.oft,
      disbursementFromDate: props.searchFilter.dfd,
      disbursementToDate: props.searchFilter.dtd,
      provincia: props.searchFilter.pro,
      isViewModal: false,
      isOpenArchievedButtonModal: false,
      auditType: "LOAN_AUDIT",
    };
  }

  /**
   * To handle click on loan application card
   */
  handleOnClickLoanApplicationCard = (applicationId) => {
    this.props.handleOnClickLoanApplicationCard(applicationId);
  };

  handleOnChangeFilterDisbursementFromDate = (disbursementFromDate) => {
    this.setState({
      disbursementFromDate: disbursementFromDate.isAfter(
        this.state.disbursementToDate
      )
        ? moment(this.state.disbursementToDate)
        : moment(disbursementFromDate),
    });
  };

  handleOnChangeFilterDisbursementToDate = (disbursementToDate) => {
    this.setState({
      disbursementToDate: disbursementToDate.isBefore(
        this.state.disbursementFromDate
      )
        ? moment(this.state.disbursementFromDate)
        : moment(disbursementToDate),
    });
  };

  handleOnChangeFilterCategory = (event) => {
    this.setState({
      filterCategory: event.target.value,
    });
  };

  /**
   * To handle change in loan id in search
   */
  handleOnChangeSearchLoanID = (event) => {
    this.setState({
      searchLoanID: event.target.value,
    });
  };

  handleOnChangeProvincia = (event) => {
    this.setState({
      provincia: event.target.value,
    });
  };

  /**
   * This function will be called when user clicks on search/filter/reset
   */
  getSearchFilterData = (isDefaultOffset) => {
    return {
      filter: {
        filterCategory: this.state.filterCategory
          ? this.state.filterCategory
          : undefined,
        disbursementFromDate: this.state.disbursementFromDate
          ? this.state.disbursementFromDate
          : undefined,
        disbursementToDate: this.state.disbursementToDate
          ? this.state.disbursementToDate
          : undefined,
        searchLoanID:
          this.state.searchLoanID === "" ? undefined : this.state.searchLoanID,
        provincia: this.state.provincia ? this.state.provincia : undefined
      },
      limit: this.state.recordsPerPage,
      offset: isDefaultOffset
        ? DEFAULT_PAGINATION_ACTIVE_PAGE
        : this.state.activePage,
      search: {},
    };
  };

  /**
   * This function will be called when user clicks on search/filter/reset
   */
  handleOnClickFilterSearch = (isDefaultOffset) => {
    isDefaultOffset &&
      this.setState({
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      });

    this.props.handleOnClickFilterSearch(
      this.getSearchFilterData(isDefaultOffset)
    );
  };

  handleDownloadLiveData = () => {
    this.props.handleDownloadLiveData(this.getSearchFilterData());
  };

  handleOnClickLoanApplicationAssign = (applicationData) => {
    this.props.handleOnClickLoanApplicationAssign(applicationData);
  };

  /**
   * This function will clear all search selections
   */
  handleOnClickResetSearchValues = () => {
    this.setState(
      {
        filterCategory: "",
        disbursementFromDate: "",
        disbursementToDate: "",
        searchLoanID: "",
        provincia: "",
        recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      },
      () => this.handleOnClickFilterSearch(true)
    );
  };

  onPageChange = ({ page, pageLength }) => {
    this.setState(
      {
        activePage: page,
        recordsPerPage: pageLength,
      },
      () => this.handleOnClickFilterSearch(false)
    );
  };

  renderSearchFilter = () => {
    let filters = [
      {
        id: "loanId",
        type: "text",
        placeholder: "ID de Aplicación",
        onChange: this.handleOnChangeSearchLoanID,
        value: this.state.searchLoanID,
        validateNumbersOnly: true,
      },
      {
        id: "category",
        type: "select",
        placeholder: "Categoría",
        onChange: this.handleOnChangeFilterCategory,
        value: this.state.filterCategory,
        dropdownList: LOAN_APPLICATION_CATEGORY,
      },
      {
        id: "fromDate",
        type: "date",
        placeholder: "Desembolso desde",
        placeholderTopClass: "placeholderTopClass",
        onChange: this.handleOnChangeFilterDisbursementFromDate,
        value: this.state.disbursementFromDate,
      },
      {
        id: "toDate",
        type: "date",
        placeholder: "Desembolso a",
        placeholderTopClass: "placeholderTopClass",
        onChange: this.handleOnChangeFilterDisbursementToDate,
        value: this.state.disbursementToDate,
      },
      {
        id: "provincia",
        type: "text",
        placeholder: "Provincia",
        onChange: this.handleOnChangeProvincia,
        value: this.state.provincia,
        name: "provincia",
      }
    ];

    return (
      <SearchFilter
        filters={filters}
        handleOnClickFilterSearch={this.handleOnClickFilterSearch}
        handleOnClickResetSearchValues={this.handleOnClickResetSearchValues}
      />
    );
  };

  renderLegends = (name, color) => {
    return (
      <Col md={2} className="legend noPadding">
        <Row className="justify-content-center align-items-center">
          <Col
            md={2}
            className="noPadding legendColorDiv"
            style={{ backgroundColor: color }}
          />
          <Col md={10} className="legendStatusText">
            {Strings(name)}
          </Col>
        </Row>
      </Col>
    );
  };

  renderLoanApplicationCards = () => {
    return this.props.loanApplicationsList.map((singleLoanApplication) => {
      let color = Utility.getColourValueForApplicationStatus(
        singleLoanApplication.status
      );

      return (
        <Col
          md={3}
          className="dashboardCards"
          key={singleLoanApplication.applicationId}
        >
          <LoanApplicationCard
            loanApplicationData={singleLoanApplication}
            color={color}
            handleOnClickLoanApplicationCard={
              this.handleOnClickLoanApplicationCard
            }
            handleOnClickLoanApplicationAssign={
              this.handleOnClickLoanApplicationAssign
            }
          />
        </Col>
      );
    });
  };

  toggleModal = (isViewModal = false) => {
    this.setState({
      isOpenArchievedButtonModal: !this.state.isOpenArchievedButtonModal,
      isViewModal,
    });
  };

  cancelClick = () => {
    this.setState({
      isOpenArchievedButtonModal: !this.state.isOpenArchievedButtonModal,
    });
  };

  renderArchievedButtonModal = () => {
    return (
      <CustomModal
        open={this.state.isOpenArchievedButtonModal}
        closeModal={this.toggleModal}
        modalCloseOnEsc={false}
        modalCloseOnOverlayClick={false}
        modalShowCloseIcon={false}
        headerTextId={Strings("archievedData")}
      >
        <ViewArchievedData
          auditType={this.state.auditType}
          closeModal={this.toggleModal}
          isViewModal={this.state.isViewModal}
          cancelClick={this.cancelClick}
          getDropdownData={this.props.dropdownData}
          onClickGenerateAudit={this.props.generateAudit}
        />
      </CustomModal>
    );
  };

  render() {
    return (
      <div>
        {this.state.isOpenArchievedButtonModal &&
          this.renderArchievedButtonModal()}
        <Button variant=""
          className="createNewApplicationText pull-right mx-1"
          onClick={() => this.toggleModal(false)}
        >
          {Strings("archievedData")}
        </Button>
        {this.renderSearchFilter()}
        <Button variant=""
          className="createNewApplicationText pull-right mx-1"
          onClick={this.handleDownloadLiveData}
          >
          {Strings("liveData")}
        </Button>
        {/* )} */}
        <Row className="legendsList">
          {LOAN_CATEGORY_LEGEND.map((legend) => {
            return this.renderLegends(legend.key, legend.color);
          })}
        </Row>

        <div className="mt-5">
          {this.props.loanApplicationsList.length > 0 ? (
            <>
              <Row>{this.renderLoanApplicationCards()}</Row>
              <Pagination
                activePage={this.state.activePage}
                recordsPerPage={this.state.recordsPerPage}
                numberOfPages={this.props.numberOfPages}
                onPageChange={this.onPageChange}
                dropup={true}
              />
            </>
          ) : (
            <Row className="noRecordsFoundMessage">
              {Strings("noRecordsFound")}
            </Row>
          )}
        </div>
      </div>
    );
  }
}
